export default __webpack_public_path__ + "da524dc7b0c624c4570640b01f87e526.png";